export default "__VITE_ASSET__fcb93ccc__"